import RestClient from '../api/restClient';
import liveStreamApi from '../api/liveStreamApi';
import Photo from '../models/photo';
import PublicLiveStream from 'redhotpie-shared-lib/models/PublicLiveStream';

class liveStreamService {
  getListLiveStreams() {
    return liveStreamApi.getListLiveStreams().then(res => {
      try {
        // console.log("res getListLiveStreams", res)
        if (res.success) {
          return { success: true, data: res.data.items };
        }
        console.log('ERROR: getListLiveStreams:', res.message);

        return res;
      } catch (e) {
        console.log('ERROR: getListLiveStreams:', e);
        throw new Error('failed');
      }
    });
  }

  getListViewerLiveStream(streamId) {
    return liveStreamApi.getListViewerLiveStream(streamId).then(res => {
      try {
        if (res.success) {
          return { success: true, data: res.data.items };
        }
        console.log('ERROR: getStreamsDetail:', res.message);

        return res;
      } catch (e) {
        console.log('ERROR: getStreamsDetail:', e);
        throw new Error('failed');
      }
    });
  }

  startLiveStream(streamId, roomId, streamName) {
    return liveStreamApi.startLiveStream(streamId, roomId, streamName).then(res => {
      if (!res.success) {
        console.warn('ERROR: startLiveStream:', res.message);
      }
      return res;
    });
  }

  watchLiveStream(xmppId, streamId) {
    return liveStreamApi.watchLiveStream(xmppId, streamId).then(res => {
      if (!res.success) {
        console.warn('ERROR: watchLiveStream:', res.message);
      }
      return { success: true, data: res.data };
    });
  }

  endLiveStream(xmppId, streamId) {
    return liveStreamApi.endLiveStream(xmppId, streamId).then(res => {
      // console.log("res", res);
      if (!res.success) {
        console.warn('ERROR: endLiveStream:', res.message);
      }
      return { success: true, data: res.data };
    });
  }

  getListLiveStreamsInRoom(roomId, { offset, size, search } = { offset: 0, size: 1000, search: '' }) {
    return liveStreamApi.getListLiveStreamsInRoom(roomId, { offset, size, search }).then(res => {
      try {
        if (res.success) {
          return { success: true, data: res.data.items.map(i => new PublicLiveStream(i)) };
        }
        console.log('ERROR: getListLiveStreamsInRoom:', res.message);

        return res;
      } catch (e) {
        console.log('ERROR: getListLiveStreamsInRoom:', e);
        throw new Error('failed');
      }
    });
  }

  uploadThumnail(formData) {
    return liveStreamApi.uploadThumbnail(formData).then(res => {
      try {
        if (res.success && res.data.items.length > 0) {
          return {
            success: true,
            data: Photo.mappingObject(res.data.items[0]),
          };
        }
        console.log('ERROR: uploadThumnail:', res.message);

        return res;
      } catch (e) {
        console.log('ERROR: uploadThumnail:', e);
        throw new Error('failed');
      }
    });
  }

  uploadThumnailUrl(linkUrl, streamId) {
    return liveStreamApi.uploadThumbnailUrl(linkUrl, streamId).then(res => {
      if (!res.success) {
        console.warn('ERROR: uploadThumnailUrl:', res.message);
      }
      return { success: true, data: res.data };
    });
  }

  cleanUpLiveStream(roomId) {
    return liveStreamApi.cleanUpLiveStream(roomId).then(res => {
      if (!res.success) {
        console.warn('ERROR: cleanUpLiveStream:', res.message);
      }
      return { success: true, data: res.data };
    });
  }
}
export default new liveStreamService();
